import type { BridgeMode, BridgeTimingMode, DraftQuestion, GameDraft } from '../../../../shared/drafts';
import type { PublishedGame } from '../../../../shared/publications';

export type OrbitalBridgeChoice = {
  id: string;
  label: string;
  correct: boolean;
  mediaUrl?: string;
};

export type OrbitalBridgeQuestion = {
  id: number;
  questionId: string;
  prompt: string;
  promptMediaUrl?: string;
  timeLimitSeconds: number | null;
  choices: OrbitalBridgeChoice[];
};

export type OrbitalBridgeConfig = {
  id: string;
  mode: BridgeMode;
  timingMode: BridgeTimingMode;
  questions: OrbitalBridgeQuestion[];
};

type BridgeSource = Pick<GameDraft | PublishedGame, 'id' | 'maxLevels' | 'questions' | 'bridgeMode' | 'timingMode'>;

function toQuestion(question: DraftQuestion, level: number, timingMode: BridgeTimingMode): OrbitalBridgeQuestion {
  return {
    id: level,
    questionId: question.id,
    prompt: question.prompt,
    promptMediaUrl: question.media?.url,
    timeLimitSeconds: timingMode === 'per-question' ? question.timeLimitSeconds ?? 30 : null,
    choices: question.choices.map((choice) => ({
      id: choice.id,
      label: choice.text,
      correct: choice.isCorrect,
      mediaUrl: choice.media?.url,
    })),
  };
}

export function draftToOrbitalBridgeConfig(source: BridgeSource): OrbitalBridgeConfig {
  const mode = source.bridgeMode ?? 'challenge';
  const timingMode = source.timingMode ?? 'none';
  const questions = Array.from({ length: source.maxLevels }, (_, index) => {
    const level = index + 1;
    const question = source.questions.find((candidate) => candidate.levels[0] === level);
    if (!question) throw new Error(`${level}. Yörünge Köprüsü sorusu bulunamadı.`);
    return toQuestion(question, level, timingMode);
  });
  return { id: source.id, mode, timingMode, questions };
}
